<template>
	<div class="partners-page">
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />
		<page-content :content="pageContent" />

		<section-title component-class="margin-top-50">
			<h2 v-html="$t('Sentence.PartnersPageTitle')"></h2>
			<p>{{ $t('Sentence.PartnersPageText') }}</p>
		</section-title>

		<div class="margin-bottom-60 margin-top-70">
			<div class="container">
				<ul class="list-none display-inline partner-list">
					<partner-box v-for="(value, key) in partners" v-once :key="key" :item="value"></partner-box>
				</ul>
			</div>
		</div>

		<div class="margin-bottom-100 margin-top-30 text-center">
			<div class="container">
				<h3>{{ $t('Sentence.PartnersPageCTA') }}</h3>
				<router-link :to="{ name: 'contacts' }" class="button button-6 margin-top-20">
					{{ $t('Link.ContactUs') }}
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import Config from '@/config'
import Helpers from '@/mixins/Helpers'
import PageContent from '@/components/partials/PageContent'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'
import PartnerBox from '@/components/atoms/PartnerBox'
import SectionTitle from '@/components/partials/SectionTitle'

export default {
	name: 'Partners',
	components: {
		PageContent,
		PageTitle,
		PartnerBox,
		SectionTitle,
	},
	mixins: [Helpers, PageInfo],
	data() {
		return {
			partners: Config.PARTNERS,
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/views/service/Partners.vue